module.exports = __webpack_public_path__ + "components/forecast-table/static/icon-chevron-left-1578a333ca6f45d4189e9b11567c069b.svg";